import React from "react";
import { calculateTotalWorkedHours } from "../../utilities/workHours";

const SERVICE_FROM_LABEL = "Service von";
const SERVICE_TO_LABEL = "Service bis";

function formatHoursHM(decimalHours: number): string {
  const totalMinutes = Math.round(decimalHours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h} Std ${m.toString().padStart(2, "0")} min`;
}

export const SummaryTableRow: React.FC<{
  data: any[][];
  columns: { title?: string }[];
}> = ({ data, columns }) => {
  const totalHours = calculateTotalWorkedHours(data); // e.g. 5.25

  return (
    <tr key="summary-row" style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
      {columns.map((col, columnIndex) => {
        let cellContent = "";

        if (columnIndex === 0) {
          cellContent = "Summe";
        }

        if (
          col?.title &&
                (col?.title.includes(SERVICE_FROM_LABEL) || col?.title.includes(SERVICE_TO_LABEL))
        ) {
          if (col?.title.includes(SERVICE_TO_LABEL)) {
            cellContent = formatHoursHM(totalHours);
          }
        }

        return (
          <td key={`summary-${columnIndex}`} style={{ padding: "8px" }}>
            {cellContent}
          </td>
        );
      })}
    </tr>
  );
};
